module.exports = __webpack_public_path__ + "img/adv1.57b186ad.png";